export default __webpack_public_path__ + "static/media/mgf.cca6f559.svg";